export default (theme) => ({
    table: {
        minWidth: 650,
    },
});
